module.exports = __webpack_public_path__ + "static/media/8.65697754.jpg";